import { Article } from '../types';

class FeaturedArticlesRepository extends ArticleRepository<Article> {
  getMany(id?: string) {
    return this._getMany({ url: '/articles/featured', query: { articleId: id }, cache: 'always' });
  }
}

export const featuredArticlesRepository = new FeaturedArticlesRepository();
